<template>
  <v-card hover @click.stop="dialog = true">
    <v-card-title>
      {{ item.name }}
    </v-card-title>
    <v-card-text>
      {{ item.description }}
    </v-card-text>
    <v-card-actions>
      <the-application-icons :application="application"></the-application-icons>

      <v-spacer></v-spacer>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click.stop="comparedToggle(id)" text v-bind="attrs" v-on="on">
            <v-icon v-if="!isSelected" color="black" large>
              mdi-playlist-plus
            </v-icon>
            <v-icon v-else color="blue darken-1" large>
              mdi-playlist-check
            </v-icon>
          </v-btn>
        </template>
        <span v-if="!isSelected">Добавить в сравнение</span>
        <span v-else>Удалить из сравнения</span>
      </v-tooltip>
    </v-card-actions>
    <the-card-dialog v-model="dialog" :dialog="dialog" :id="id">
    </the-card-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { GETTERS, MUTATIONS } from "@/store";
import TheCardDialog from "@/components/TheCardDialog";
import TheApplicationIcons from "./TheApplicationIcons.vue";

export default {
  name: "CardsItem",
  components: { TheCardDialog, TheApplicationIcons },
  props: { id: { type: Number, required: true } },
  data: () => ({ dialog: false }),
  computed: {
    ...mapGetters({
      isLoading: GETTERS.IS_LOADING,
      cards: GETTERS.CARDS,
      compared: GETTERS.COMPARED_CARDS,
    }),
    item() {
      const id = this.id;
      return this.cards.find((item) => item.id === id);
    },
    isSelected() {
      return this.compared.includes(this.id);
    },
    application() {
      return this.item.application || "";
    },
  },
  methods: {
    ...mapMutations({
      comparedToggle: MUTATIONS.COMPARED_CARDS_TOGGLE,
    }),
  },
};
</script>
